import React from "react"


const reactImport =  React

export default reactImport
